// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YltgwiuXQsdY822akY_Q{flex-direction:column;display:flex}.rtwcZdqeI60Q53YJQw5n{justify-content:space-between;align-items:center;display:flex}.Hyee2BLM54cl_zAHcE8q{width:100%;height:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `YltgwiuXQsdY822akY_Q`,
	"header": `rtwcZdqeI60Q53YJQw5n`,
	"image": `Hyee2BLM54cl_zAHcE8q`
};
export default ___CSS_LOADER_EXPORT___;
